import React from "react";
import Langs from '../../app/lang/langs';
import styles from './Permissions.module.css';
import PermissionRow from './PermissionRow';

/**
 * A permission section: header + list of permission rows.
 *
 * Props:
 * - titleKey: string — lang key for the section header (e.g. "GLOBAL_PERMISSIONS")
 * - scopes: string[] — list of scope keys to render rows for
 * - scopeType: "global" | "team"
 * - role: string — the role name
 * - activePermissions: object — permissions for this role+scopeType
 * - onPermissionChange: (role, scopeType, scope, newType) => void
 */
export default function PermissionSection({ titleKey, scopes, scopeType, role, activePermissions, onPermissionChange }) {
    return (
        <>
            <div className={styles.sectionHeader}><Langs str={titleKey} /></div>
            {scopes.map(scope => (
                <PermissionRow
                    key={scope}
                    scope={scope}
                    scopeType={scopeType}
                    role={role}
                    activePermissions={activePermissions}
                    onPermissionChange={onPermissionChange}
                />
            ))}
        </>
    );
}
